import { BelongsToReferenceField, pageCollectionFields } from 'drapcode-constant';
import { dynamicSort } from '../../../../common/utils/api_utils';
import {
  dateFormatOptions,
  getCurrentSubTenantFieldsTraits,
  getCurrentTenantFieldsTraits,
  getCurrentUserFieldsTraits,
  getCurrentUserSettingsFieldsTraits,
  getDataItemIdFieldsTraits,
  getFieldsTraits,
  getFieldsTraitsOptionsForAutocomplete,
  getSelectLabelFields,
} from './traitsApi';
import {
  createFormForCollection,
  getFormComponents,
  getCollectionFieldElements,
} from './formComponent';
import {
  addFieldsTraitsIntoComponent,
  findParentSelectedCollection,
} from '../dataGroup/innerComponents';
import { getCollectionFields, getInstalledPlugins } from '../pluginComponentApi';
import { processSteps } from './utils';
import { findDetailsComponentCollection } from '../collectionTraits/utils';
import voca from 'voca';
const workflowEventNoLabel = {
  type: 'webconnect-event',
  label: false,
  name: 'onsubmit',
};
const workflowEventWithLabel = {
  type: 'webconnect-event',
  label: 'Event',
  name: 'onchange',
};
export default async function (editor, opts = {}) {
  console.log('🚀 ~ file: components.js:31 ~ opts:', opts);
  const {
    pageCollection,
    pfx,
    projectId,
    labelFieldName,
    collections,
    labelColFileDropzone,
    version,
    snippetType,
  } = opts;
  const domc = editor.DomComponents;
  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;

  const installedPlugins = projectId ? await getInstalledPlugins(projectId, version) : '';
  const multiTenantPlugin =
    installedPlugins && installedPlugins.find((plugin) => plugin.code === 'MULTI_TENANT_SAAS');
  const { setting: multiTenantSetting } = multiTenantPlugin || '';
  const { multiTenantCollection, userSettingsCollection, subTenantCollection } =
    multiTenantSetting || '';
  const multiTenantCollectionObj = collections.find(
    (collection) => collection.uuid === multiTenantCollection,
  );
  const userSettingsCollectionObj = collections.find(
    (collection) => collection.uuid === userSettingsCollection,
  );
  const subTenantCollectionObj = collections.find(
    (collection) => collection.uuid === subTenantCollection,
  );
  const fileActivityTrackerPlugin =
    installedPlugins && installedPlugins.find((plugin) => plugin.code === 'FILE_ACTIVITY_TRACKER');

  domc.addType('collection-form', {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          name: 'Collection Form',
          droppable: ':not(form)',
          draggable: ':not(form)',
          method: '',
          action: '',
          collectionName: '',
          projectId: projectId,
          version: version,
          serverUrl: `${process.env.REACT_EXCHANGE_ENGINE}`,
          method: 'POST',
          traits: [
            {
              type: 'dynamic-form-collection',
              label: false,
              name: 'collectionName',
              changeProp: 1,
            },
            {
              type: 'select',
              label: 'Method',
              name: 'method',
              default: 'POST',
              options: [
                { value: 'POST', name: 'POST' },
                { value: 'PUT', name: 'PUT' },
              ],
              changeProp: 1,
            },
            {
              type: 'checkbox',
              label: 'Persist Data',
              name: 'persistData',
            },
            ...domc.getType('default').model.prototype.defaults.traits,
          ],
          attributes: { action: '' },
        },

        async init() {
          const attrs = this.getAttributes();
          const validationUuid = attrs['data-form-validation'];
          const collectionName = attrs['data-form-collection'];
          let selectedCollection = null;
          if (collections) {
            selectedCollection = collections.find(
              (collection) => collection.collectionName === collectionName,
            );
          }

          let validationOpts = [{ name: '- Select One -', value: '' }];
          if (selectedCollection) {
            const validations = selectedCollection.validations;
            if (validations && validations.length > 0) {
              validations.sort(dynamicSort('customValidationName')).forEach((validation, key) => {
                validationOpts.push({
                  value: validation.uuid,
                  name: validation.customValidationName,
                });
              });
            }

            const validationTrait = {
              type: 'select',
              label: false,
              name: 'validationUuid',
              changeProp: 1,
              options: validationOpts,
              value: validationUuid || '',
            };
            this.addTrait(validationTrait, { at: this.getTraitIndex('collectionName') + 1 });
            this.addTrait(workflowEventNoLabel, { at: this.getTraitIndex('validationUuid') + 1 });

            if (pageCollection && pageCollection.collectionId) {
              const appendItemIdTrait = {
                type: 'checkbox',
                label: 'Skip Item Id',
                name: 'disableItemId',
              };
              this.addTrait(appendItemIdTrait, { at: this.getTraitIndex('method') + 1 });
            }
          } else {
            this.removeTrait('onsubmit');
            this.removeTrait('validationUuid');
          }

          const componentMethod = this.get('method');
          const dataItemIdFromTrait = this.getTrait('getDataItemIdFrom');
          const dataItemIdFieldTrait = this.getTrait('itemIdField');
          const createItemFormTrait = this.getTrait('createItem');
          if (componentMethod === 'PUT') {
            const dataItemIdFromValue = this.get('getDataItemIdFrom');
            const dataItemIdFieldValue = this.get('itemIdField');
            if (!dataItemIdFromValue) {
              this.set('getDataItemIdFrom', 'DEFAULT');
            }
            if (!dataItemIdFromTrait) {
              const options = [{ value: 'DEFAULT', name: 'Default' }];
              const { parentCollectionName, parentComponentType } = findDetailsComponentCollection(
                this,
                snippetType,
                pageCollection,
              );
              if (parentCollectionName) {
                options.push({
                  value: 'PARENT_COLLECTION',
                  name: `Collection (${voca.titleCase(parentComponentType.replaceAll('_', ' '))})`,
                });
              }
              if (pageCollection) {
                options.push({ value: 'PAGE_COLLECTION', name: 'Page Collection' });
              }
              options.push({ value: 'CURRENT_USER_FIELD', name: 'Current Logged In User' });
              if (multiTenantCollection) {
                const multiTenantCollectionName = multiTenantCollectionObj
                  ? multiTenantCollectionObj.collectionTitle
                  : 'Tenant';
                options.push({
                  value: 'CURRENT_TENANT_FIELD',
                  name: `Current Logged In ${multiTenantCollectionName}`,
                });
              }
              if (userSettingsCollection) {
                const userSettingsCollectionName = userSettingsCollectionObj
                  ? userSettingsCollectionObj.collectionTitle
                  : 'User Settings';
                options.push({
                  value: 'CURRENT_USER_SETTINGS_FIELD',
                  name: `Current Logged In ${userSettingsCollectionName}`,
                });
              }
              if (subTenantCollection) {
                const subTenantCollectionName = subTenantCollectionObj
                  ? subTenantCollectionObj.collectionTitle
                  : 'Sub Tenant';
                options.push({
                  value: 'CURRENT_SUB_TENANT_FIELD',
                  name: `Current Logged In ${subTenantCollectionName}`,
                });
              }
              options.push({ value: 'BROWSER_SESSION_STORAGE', name: 'Browser Session Storage' });
              options.push({ value: 'ENTITY_COLLECTION', name: 'Collection(Browser Storage)' });

              this.addTrait(
                {
                  type: 'select',
                  label: 'Get Item Id From',
                  name: 'getDataItemIdFrom',
                  options: [...options],
                  value: dataItemIdFromValue,
                  changeProp: 1,
                },
                { at: this.getTraitIndex('method') + 1 },
              );
            }
            if (!dataItemIdFieldTrait) {
              await getTraitForItemIdField(
                this,
                attrs,
                dataItemIdFromValue,
                dataItemIdFieldTrait,
                collections,
                pageCollection,
                multiTenantCollection,
                userSettingsCollection,
                subTenantCollection,
                dataItemIdFieldValue,
                snippetType,
              );
            }
          } else {
            if (dataItemIdFromTrait) {
              this.removeTrait('getDataItemIdFrom');
            }
            if (dataItemIdFieldTrait) {
              this.removeTrait('itemIdField');
            }
            if (createItemFormTrait) {
              this.removeTrait('createItem');
            }
          }

          this.on('change:collectionName', this.handleCollectionChange);
          this.on('change:validationUuid', this.handleValidationChange);
          this.on('change:method', this.handleMethodChange);
          this.on('change:getDataItemIdFrom', this.handleDataItemIdFromChange);
          this.on('change:itemIdField', this.handleItemIdField);
          this.on('change:entityStorageKey', this.handleEntityStorageKey);
        },
        async handleCollectionChange() {
          const collectionName = this.get('collectionName');
          const cmsProgressBarContainer = document.querySelector('.settings--progress-bar');
          const cmsProgressStep = document.querySelector('.settings--progress');
          const attrs = this.getAttributes();
          //TODO: Dynamically handle for version
          attrs['action'] = `collection-form/${collectionName}/items`;
          attrs['data-form-collection'] = collectionName;
          delete attrs['data-form-validation'];
          this.setAttributes(attrs);
          const collection = await getFormComponents(collectionName, collections);
          if (collectionName && collection) {
            const validations = collection.validations;
            let validationOpts = [{ name: '- Select One -', value: '' }];
            if (validations && validations.length > 0) {
              validations.sort(dynamicSort('customValidationName')).forEach((validation, key) => {
                validationOpts.push({
                  value: validation.uuid,
                  name: validation.customValidationName,
                });
              });
            }
            this.removeTrait('validationUuid');
            const validationTrait = {
              type: 'select',
              label: false,
              name: 'validationUuid',
              changeProp: 1,
              options: validationOpts,
              value: '',
            };
            this.addTrait(validationTrait, { at: this.getTraitIndex('collectionName') + 1 });
            processSteps(cmsProgressStep, false, cmsProgressBarContainer, 'stepOne');
            this.removeTrait('onsubmit');
            this.addTrait(workflowEventNoLabel, { at: this.getTraitIndex('validationUuid') + 1 });
            let isUpdateForm = false;
            if (pageCollection && pageCollection.collectionId) {
              isUpdateForm = pageCollection.collectionId === collection.collectionName;
              if (isUpdateForm) {
                this.addAttributes({ method: 'PUT' });
                this.removeTrait('disableItemId');
                const appendItemIdTrait = {
                  type: 'checkbox',
                  label: 'Skip Item Id',
                  name: 'disableItemId',
                };
                this.addTrait(appendItemIdTrait, { at: this.getTraitIndex('method') + 1 });
              }
            }
            const formElements = await createFormForCollection(
              collection,
              projectId,
              version,
              collections,
              isUpdateForm,
            );
            let form = `
            <div class="col-12 col-md-12">
              <h4 class="title">${collection.collectionTitle} Form</h4>
            </div>
            <div class="form-container row mx-auto" draggable="false" data-gjs-copyable="false" 
            data-gjs-selectable="true" data-gjs-custom-name="Form Container">
            ${formElements}
            <div class="form-group no-border-bottom col-12 col-md-12">
              <button type="submit" class="btn btn-primary">Submit</button>
              <button type="button" class="btn btn-danger ms-2 ml-2">Cancel</button>
            </div>
            </div>
          </div>
            `;
            this.components(form);
          } else {
            this.removeTrait('onsubmit');
            this.removeTrait('validationUuid');
          }
        },
        async handleValidationChange() {
          const collectionName = this.get('collectionName');
          const validationUuid = this.get('validationUuid');
          const cmsProgressBarContainer = document.querySelector('.settings--progress-bar');
          const cmsProgressStep = document.querySelector('.settings--progress');
          if (validationUuid && validationUuid !== 'null' && validationUuid !== '---') {
            this.addAttributes({
              action: `collection-form/${collectionName}/items`,
              'data-form-collection': collectionName,
            });
            const collection = await getFormComponents(collectionName, collections);
            if (collection) {
              const validations = collection.validations;
              if (validations) {
                let selectedValidation = validations.find(
                  (validation) => validation.uuid === validationUuid,
                );
                if (selectedValidation) {
                  this.addAttributes({
                    'data-form-validation': validationUuid,
                  });
                }
              }
            }
            processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepTwo');
          } else {
            const attrs = this.getAttributes();
            delete attrs['data-form-validation'];

            this.setAttributes(attrs);
            processSteps(cmsProgressStep, false, cmsProgressBarContainer);
            processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepOne');
          }
        },
        async handleMethodChange() {
          const componentMethod = this.get('method');
          const attrs = this.getAttributes();
          const dataItemIdFromTrait = this.getTrait('getDataItemIdFrom');
          if (componentMethod === 'PUT') {
            const dataItemIdFromValue = this.get('getDataItemIdFrom');
            if (!dataItemIdFromValue) {
              this.set('getDataItemIdFrom', 'DEFAULT');
            }
            if (!dataItemIdFromTrait) {
              const options = [{ value: 'DEFAULT', name: 'Default' }];
              const { parentCollectionName, parentComponentType } = findDetailsComponentCollection(
                this,
                snippetType,
                pageCollection,
              );
              if (parentCollectionName) {
                options.push({
                  value: 'PARENT_COLLECTION',
                  name: `Collection (${voca.titleCase(parentComponentType.replaceAll('_', ' '))})`,
                });
              }
              if (pageCollection) {
                options.push({ value: 'PAGE_COLLECTION', name: 'Page Collection' });
              }
              options.push({ value: 'CURRENT_USER_FIELD', name: 'Current Logged In User' });
              if (multiTenantCollection) {
                const multiTenantCollectionName = multiTenantCollectionObj
                  ? multiTenantCollectionObj.collectionTitle
                  : 'Tenant';
                options.push({
                  value: 'CURRENT_TENANT_FIELD',
                  name: `Current Logged In ${multiTenantCollectionName}`,
                });
              }
              if (userSettingsCollection) {
                const userSettingsCollectionName = userSettingsCollectionObj
                  ? userSettingsCollectionObj.collectionTitle
                  : 'User Settings';
                options.push({
                  value: 'CURRENT_USER_SETTINGS_FIELD',
                  name: `Current Logged In ${userSettingsCollectionName}`,
                });
              }
              if (subTenantCollection) {
                const subTenantCollectionName = subTenantCollectionObj
                  ? subTenantCollectionObj.collectionTitle
                  : 'Sub Tenant';
                options.push({
                  value: 'CURRENT_SUB_TENANT_FIELD',
                  name: `Current Logged In ${subTenantCollectionName}`,
                });
              }
              options.push({ value: 'BROWSER_SESSION_STORAGE', name: 'Browser Session Storage' });
              options.push({ value: 'ENTITY_COLLECTION', name: 'Collection(Browser Storage)' });
              this.addTrait(
                {
                  type: 'select',
                  label: 'Get Item Id From',
                  name: 'getDataItemIdFrom',
                  options: [...options],
                  value: dataItemIdFromValue,
                  changeProp: 1,
                },
                { at: this.getTraitIndex('method') + 1 },
              );
            }
          } else {
            this.removeTrait('getDataItemIdFrom');
            this.removeTrait('itemIdField');
            if (attrs['getDataItemIdFrom']) {
              delete attrs['getDataItemIdFrom'];
            }
            if (attrs['itemIdField']) {
              delete attrs['itemIdField'];
            }
            if (attrs['createItem']) {
              delete attrs['createItem'];
            }
            attrs['method'] = componentMethod;
            this.setAttributes(attrs);
          }
        },
        async handleDataItemIdFromChange() {
          const dataItemIdFromValue = this.get('getDataItemIdFrom');
          const attrs = this.getAttributes();
          const collectionName = this.get('collectionName');
          attrs['getdataitemidfrom'] = dataItemIdFromValue;
          this.setAttributes(attrs);
          if (collectionName) {
            const itemIdFieldTrait = this.getTrait('itemIdField');
            const itemIdField = this.get('itemIdField');
            if (itemIdFieldTrait) {
              this.removeTrait('itemIdField');
            }
            await getTraitForItemIdField(
              this,
              attrs,
              dataItemIdFromValue,
              itemIdFieldTrait,
              collections,
              pageCollection,
              multiTenantCollection,
              userSettingsCollection,
              subTenantCollection,
              itemIdField,
              snippetType,
            );
          }
        },
        handleItemIdField() {
          const itemIdFieldValue = this.get('itemIdField');
          const createItemFormTrait = this.getTrait('createItem');
          const dataItemIdFromValue = this.get('getDataItemIdFrom');
          const attrs = this.getAttributes();
          attrs['itemIdField'] = itemIdFieldValue;
          this.setAttributes(attrs);
          if (dataItemIdFromValue !== 'BROWSER_SESSION_STORAGE') {
            if (!createItemFormTrait) {
              if (itemIdFieldValue && itemIdFieldValue.includes('.')) {
                this.addTrait(
                  {
                    type: 'checkbox',
                    label: "Create Item if doesn't Exist",
                    name: 'createItem',
                    value: false,
                    valueTrue: 'true',
                    valueFalse: 'false',
                  },
                  { at: this.getTraitIndex('itemIdField') + 1 },
                );
              }
            } else {
              if (itemIdFieldValue && !itemIdFieldValue.includes('.')) {
                this.removeTrait('createItem');
              }
            }
          } else {
            if (createItemFormTrait) this.removeTrait('createItem');
          }
        },
        async handleEntityStorageKey() {
          const entityStorageKey = this.get('entityStorageKey');
          const attrs = this.getAttributes();
          attrs['data-entity-key'] = entityStorageKey;
          this.setAttributes(attrs);
          const itemIdField = this.get('itemIdField');
          const itemIdFieldTrait = this.getTrait('itemIdField');
          await addCollectionFieldTrait(
            this,
            collections,
            entityStorageKey,
            'entityStorageKey',
            itemIdFieldTrait,
            itemIdField,
          );
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === 'collection-form') {
            return {
              type: 'collection-form',
            };
          }
        },
      },
    ),
    view: defaultView.extend({
      events: {
        submit(e) {
          e.preventDefault();
        },
      },
      init({ model }) {
        this.listenTo(model, 'change:collectionName', this.updateScript);
      },
    }),
  });

  const columnType = domc.getType('column');
  const columnModel = columnType.model;
  const columnView = columnType.view;
  domc.addType('collection-field', {
    model: columnModel.extend(
      {
        defaults: {
          ...columnModel.prototype.defaults,
          droppable: ':not(form)',
          draggable: ':not(form)',
          projectId: projectId,
          version: version,
          script: function () {
            let collectionField = '{[ collectionField ]}';
            const tagNameCollectionField = this.tagName;
            if (
              typeof loadDynamicSelectOptions !== 'undefined' &&
              tagNameCollectionField === 'SELECT'
            ) {
              loadDynamicSelectOptions(this, collectionField);
            }
          },
        },
        init() {
          let collectionForm = this.closestType('collection-form');
          collectionForm = collectionForm
            ? collectionForm
            : this.closestType('login-form')
            ? this.closestType('login-form')
            : this.closestType('sign-up-form');

          const traits = this.get('traits');
          traits.forEach((trait) => this.removeTrait(''));
          if (collectionForm && collectionForm.getAttributes()['data-form-collection']) {
            getFieldsTraits(
              this.get('type'),
              collectionForm.getAttributes()['data-form-collection'],
              collections,
              true,
            ).then((res) => {
              if (res) {
                const collectionFieldTrait = this.getTrait('collectionField');
                if (!collectionFieldTrait) {
                  this.addTrait(res, { at: 0 });
                }
                const inputField = this.get('traits').where({ name: 'collectionFormField' })[0];
                const options = inputField.get('options');
                const selectedValue = options.find((opt) => {
                  if (opt.id !== '') {
                    const optIdValue = opt.id;
                    const optIdValueString = optIdValue
                      ? optIdValue.replaceAll("'", '"').replaceAll('\\"', '"')
                      : '';
                    const optIdValueJson = optIdValueString ? JSON.parse(optIdValueString) : '';
                    return optIdValueJson.fieldName === this.getAttributes()['name'];
                  }
                });
                if (selectedValue) {
                  let valueToSet = JSON.stringify(selectedValue.id);
                  valueToSet = valueToSet.substr(1, valueToSet.length - 2);
                  this.set('collectionField', `${valueToSet}`);
                }
              }
            });
          }
          this.on('change:collectionFormField', this.handleCollectionFormFieldChange);
        },

        async handleCollectionFormFieldChange() {
          const collectionForm = this.closestType('collection-form');
          const collectionName = collectionForm
            ? collectionForm.getAttributes()['data-form-collection']
            : '';
          const collectionFormFieldValue = this.get('collectionFormField');
          const collectionFormFieldValueString = collectionFormFieldValue
            ? collectionFormFieldValue.replaceAll("'", '"').replaceAll('\\"', '"')
            : '';
          const collectionField = collectionFormFieldValueString
            ? JSON.parse(collectionFormFieldValueString)
            : '';

          if (collectionField) {
            let isUpdateForm = false;
            if (pageCollection && pageCollection.collectionId && collectionName) {
              isUpdateForm = pageCollection.collectionId === collectionName;
            }
            const fieldElements = await getCollectionFieldElements(
              collectionField,
              projectId,
              version,
              isUpdateForm,
            );
            this.replaceWith(fieldElements);
          }
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === 'collection-field') {
            return {
              type: 'collection-field',
            };
          }
        },
      },
    ),
    view: columnView.extend({
      events: {
        submit(e) {
          e.preventDefault();
        },
      },
      init({ model }) {
        this.listenTo(model, 'change:collectionField', this.updateScript);
      },
    }),
  });

  domc.addType('input', {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          droppable: ':not(form)',
          draggable: ':not(form)',
          projectId: projectId,
          version: version,
          traits: [
            {
              type: 'form-element-trait',
              label: false,
              name: 'data-element-field-name',
              customLabel: 'Get Value From',
              content: false,
            },
          ].concat(domc.getType('input').model.prototype.defaults.traits),
        },
        async init() {
          const collectionForm = this.closestType('collection-form');
          if (collectionForm && collectionForm.getAttributes()['data-form-collection']) {
            getFieldsTraits(
              this.get('type'),
              collectionForm.getAttributes()['data-form-collection'],
              collections,
            ).then((res) => {
              if (res) {
                this.addTrait(res, { at: 0 });
              }
            });
          }
          const selectedCollection = findParentSelectedCollection(this);
          if (selectedCollection) this.handleSelectedCollectionChange();
          this.on('change:selectedCollection', this.handleSelectedCollectionChange);
          this.on('change:data-element-field-name', this.handleGetValueFromChange);
        },
        handleGetValueFromChange() {
          const valueFrom = this.get('data-element-field-name');
          if (valueFrom == 'staticValue') {
            this.addTrait({
              name: 'value',
              label: 'Value',
              type: 'text',
            });
          } else {
            this.removeTrait('value');
          }
        },
        handleSelectedCollectionChange() {
          addFieldsTraitsIntoComponent(this, collections);
        },
      },
      {
        isComponent(el) {
          if (
            el.tagName === 'INPUT' &&
            ['text', 'url', 'password', 'tel', 'email', 'number', 'date'].includes(el.type)
          ) {
            return { type: 'input' };
          } else {
          }
        },
      },
    ),
    view: defaultView.extend({
      events: {
        submit(e) {
          e.preventDefault();
        },
      },
      init({ model }) {},
    }),
  });
  domc.addType('checkbox', {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          droppable: ':not(form)',
          draggable: ':not(form)',
          projectId: projectId,
          version: version,
          traits: [
            {
              type: 'form-element-trait',
              label: false,
              name: 'data-element-field-name',
              customLabel: 'Get Value From',
              content: false,
            },
          ].concat(domc.getType('checkbox').model.prototype.defaults.traits),
          script: function () {
            let collectionField = '{[ collectionField ]}';
            let finderUuid = '{[ finderUuid ]}';
            let workflowUuid = '{[ workflowUuid ]}';
            let dataSearchForm = this.closest('.search-form');

            let formEl = this.closest('form');
            let isModal = false;
            const isModalForm = formEl && formEl.closest('[id^=modal-container]');
            isModal = isModalForm ? true : false;

            if (isModal) {
              formEl.setAttribute('data-form-modal', true);
              this.setAttribute('data-collection-field', collectionField);
            }

            if (dataSearchForm) {
              if (typeof loadSearchFormDynamicSelectOptions !== 'undefined') {
                loadSearchFormDynamicSelectOptions(this, collectionField, finderUuid);
              }
            } else {
              if (typeof loadDynamicSelectOptions !== 'undefined') {
                loadDynamicSelectOptionsForRadio(this, collectionField, finderUuid, workflowUuid);
              }
            }
          },
        },
        init() {
          let collectionForm = this.closestType('collection-form');
          collectionForm = collectionForm
            ? collectionForm
            : this.closestType('sign-up-form')
            ? this.closestType('sign-up-form')
            : this.closestType('search-form');
          if (collectionForm && collectionForm.getAttributes()['data-form-collection']) {
            const updateTraits = this.get('traits').models.filter((trait) => {
              return trait.get('type') !== 'select-options';
            });
            this.set('traits', updateTraits);
            const attributes = this.getAttributes();
            getFieldsTraits(
              attributes['data-component-type']
                ? attributes['data-component-type']
                : this.get('type'),
              collectionForm.getAttributes()['data-form-collection'],
              collections,
            ).then(async (res) => {
              if (res) {
                this.addTrait(res, { at: 0 });
                const inputField = this.get('traits').where({ type: 'input-field' })[0];
                const options = inputField.get('options');
                const selectedValue = options.find((opt) => {
                  if (opt.id !== '') {
                    return JSON.parse(opt.id).fieldName === this.getAttributes()['name'];
                  }
                });
                if (selectedValue && selectedValue.id) {
                  const { type, refCollection } = JSON.parse(selectedValue.id);
                  const collectionName = refCollection ? refCollection.collectionName : '';
                  if (collectionName) {
                    const refCollectionDetail = await getCollectionFields(
                      collectionName,
                      collections,
                    );

                    const { finders } = refCollectionDetail;
                    const finderOptions = finders.map((finder) => {
                      return { value: finder.uuid, name: finder.name };
                    });

                    this.addTrait({
                      type: 'select',
                      label: 'filter',
                      name: 'finderUuid',
                      options: finderOptions,
                      changeProp: 1,
                    });
                  }

                  // inputField.set('options', res);
                  let valueToSet = JSON.stringify(selectedValue.id);
                  valueToSet = valueToSet.substr(1, valueToSet.length - 2);
                  this.set('collectionField', `${valueToSet}`);
                }

                if (collectionForm.getAttributes()['data-form-collection']) {
                  const collectionName = collectionForm.getAttributes()['data-form-collection'];
                  const collectionDetail = await getCollectionFields(collectionName, collections);
                  const workflows = collectionDetail ? collectionDetail.workflows : [];
                  const defaultOption = { value: '', name: '- Select One -' };
                  const options = workflows.map((workflow) => {
                    return { value: workflow.uuid, name: workflow.name };
                  });
                  const workflowOptions = [defaultOption, ...options];
                  this.addTrait({
                    type: 'select',
                    label: 'workflow',
                    name: 'workflowUuid',
                    options: workflowOptions,
                    changeProp: 1,
                  });
                }
              }
            });
            const selectedCollection = findParentSelectedCollection(collectionForm);
            console.log('selectedCollectionselectedCollection', selectedCollection);
            if (selectedCollection) this.handleSelectedCollectionChange();
          }
          this.on('change:selectedCollection', this.handleSelectedCollectionChange);
          this.on('change:finderUuid', this.handleFinderChange);
        },
        handleSelectedCollectionChange() {
          addFieldsTraitsIntoComponent(this, collections);
        },
        async handleFinderChange() {
          const finderUuid = this.get('finderUuid');
          const attrs = this.getAttributes();
          if (finderUuid) {
            attrs['data-select-finder-id'] = finderUuid;
          } else {
            delete attrs['data-select-finder-id'];
          }
          this.setAttributes(attrs);
        },
      },
      {
        isComponent(el) {
          if (el.tagName === 'INPUT' && el.type === 'checkbox') {
            return { type: 'checkbox' };
          }
        },
      },
    ),
    view: defaultView.extend({
      events: {
        submit(e) {
          e.preventDefault();
        },
      },
      init({ model }) {
        this.listenTo(model, 'change:collectionField', this.updateScript);
        this.listenTo(model, 'change:finderUuid', this.updateScript);
        this.listenTo(model, 'change:workflowUuid', this.updateScript);
      },
    }),
  });
  domc.addType('textarea', {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          droppable: ':not(form)',
          draggable: ':not(form)',
          projectId: projectId,
          version: version,
          traits: [
            {
              type: 'form-element-trait',
              label: false,
              name: 'data-element-field-name',
              customLabel: 'Get Value From',
              content: false,
            },
          ].concat(domc.getType('textarea').model.prototype.defaults.traits),
        },
        init() {
          const collectionForm = this.closestType('collection-form');
          if (collectionForm && collectionForm.getAttributes()['data-form-collection']) {
            getFieldsTraits(
              this.get('type'),
              collectionForm.getAttributes()['data-form-collection'],
              collections,
            ).then((res) => {
              if (res) {
                this.addTrait(res, { at: 0 });
              }
            });
            const selectedCollection = findParentSelectedCollection(this);
            if (selectedCollection) this.handleSelectedCollectionChange();
          }
          this.on('change:selectedCollection', this.handleSelectedCollectionChange);
        },
        handleSelectedCollectionChange() {
          addFieldsTraitsIntoComponent(this, collections);
        },
      },
      {
        isComponent(el) {
          if (el.tagName === 'TEXTAREA' && el.type === 'textarea') {
            return { type: 'textarea' };
          } else {
          }
        },
      },
    ),
    view: defaultView.extend({
      events: {
        submit(e) {
          e.preventDefault();
        },
      },
      init({ model }) {},
    }),
  });
  domc.addType('file-input', {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          droppable: ':not(form)',
          draggable: ':not(form)',
          projectId: projectId,
          version: version,
          traits: [
            {
              type: 'form-element-trait',
              label: false,
              name: 'data-element-field-name',
              customLabel: 'Get Value From',
              content: false,
            },
          ].concat(domc.getType('file-input').model.prototype.defaults.traits),
        },
        init() {
          const collectionForm = this.closestType('collection-form');
          if (collectionForm && collectionForm.getAttributes()['data-form-collection']) {
            getFieldsTraits(
              this.get('type'),
              collectionForm.getAttributes()['data-form-collection'],
              collections,
            ).then((res) => {
              if (res) {
                this.addTrait(res, { at: 0 });
              }
            });
          }
        },
      },
      {
        isComponent(el) {
          if (el.tagName === 'INPUT' && el.type === 'file') {
            return { type: 'file-input' };
          }
        },
      },
    ),
    view: defaultView.extend({
      events: {
        submit(e) {
          e.preventDefault();
        },
      },
    }),
  });
  domc.addType('select', {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          droppable: ':not(form)',
          draggable: ':not(form)',
          projectId: projectId,
          version: version,
          traits: [
            {
              type: 'form-element-trait',
              label: false,
              name: 'data-element-field-name',
              customLabel: 'Get Value From',
              content: false,
            },
            ...domc.getType('select').model.prototype.defaults.traits,
            workflowEventWithLabel,
            {
              type: 'select',
              label: 'Placeholder pattern (Optional)',
              name: 'placeholderPattern',
              info: `Change the placeholder pattern for the select field. This will be used to show the placeholder in the select field.`,
              default: 'DEFAULT',
              options: [
                { id: 'DEFAULT', name: 'Select with Field Name (i.e.: - Select Field -)' },
                { id: 'ONLY_FIELD_NAME', name: 'Only Field Name (i.e.: - Field -)' },
                { id: 'ONLY_SELECT', name: 'Only Select (i.e.: - Select -)' },
              ],
            },
          ],
          script: function () {
            let collectionField = '{[ collectionField ]}';
            let finderUuid = '{[ finderUuid ]}';
            let workflowUuid = '{[ workflowUuid ]}';
            let dataSearchForm = this.closest('.search-form');
            const dropdownDataFrom = '{[ getDropdownDataFrom ]}';
            const currentUserField = '{[ currentUserCollectionField ]}';
            const currentTenantField = '{[ currentTenantCollectionField ]}';
            const currentUserSettingsField = '{[currentUserSettingsCollectionField]}';
            const currentSubTenantField = '{[ currentSubTenantCollectionField ]}';

            if (dataSearchForm) {
              if (typeof loadSearchFormDynamicSelectOptions !== 'undefined') {
                loadSearchFormDynamicSelectOptions(
                  this,
                  collectionField,
                  finderUuid,
                  dropdownDataFrom,
                  currentUserField,
                  null,
                  currentTenantField,
                  currentUserSettingsField,
                  currentSubTenantField,
                );
              }
            } else {
              let formEl = this.closest('form');
              let isModal = false;
              const isModalForm = formEl && formEl.closest('[id^=modal-container]');
              isModal = isModalForm ? true : false;
              if (isModal) {
                formEl.setAttribute('data-form-modal', true);
                this.setAttribute('data-collection-field', collectionField);
                this.setAttribute('data-user-collection-field', currentUserField);
                this.setAttribute('data-tenant-collection-field', currentTenantField);
                this.setAttribute('data-user-settings-collection-field', currentUserSettingsField);
                this.setAttribute('data-sub-tenant-collection-field', currentSubTenantField);
              }
              if (typeof loadDynamicSelectOptions !== 'undefined') {
                loadDynamicSelectOptions(
                  this,
                  collectionField,
                  finderUuid,
                  workflowUuid,
                  isModal,
                  dropdownDataFrom,
                  currentUserField,
                  null,
                  currentTenantField,
                  currentUserSettingsField,
                  currentSubTenantField,
                );
              }
            }
          },
        },
        async init() {
          const finderUuid = this.get('finderUuid');
          const dropdownDataFromValue = this.get('getDropdownDataFrom');
          if (!dropdownDataFromValue) {
            this.set('getDropdownDataFrom', 'FILTER');
          }
          this.removeTrait('');
          let collectionForm =
            this.closestType('collection-form') ||
            this.closestType('sign-up-form') ||
            this.closestType('search-form') ||
            this.closestType('survey-form-field');

          let userMultipleRolesForm = this.closestType('user-multiple-role-form');
          console.log(
            '🚀 ~ file: components.js:1056 ~ init ~ userMultipleRolesForm:',
            userMultipleRolesForm,
          );

          if (collectionForm) {
            const collectionName = collectionForm.getAttributes()['data-form-collection'];
            if (collectionName) {
              const trait = await getFieldsTraits(this.get('type'), collectionName, collections);
              const collectionFieldTrait = this.getTrait('collectionField');
              const attr = this.get('attributes');
              const fieldName = attr['name'];
              getSelectLabelFields(collectionName, collections, fieldName).then((res) => {
                this.addTrait(res, { at: 0 });
              });
              const currentUserCollectionFieldsTraitConfig = await getCurrentUserFieldsTraits(
                this.get('type'),
                collectionName,
                collections,
              );
              const currentTenantCollectionFieldsTraitConfig = await getCurrentTenantFieldsTraits(
                this.get('type'),
                collectionName,
                collections,
                multiTenantCollection,
              );
              const currentUserSettingsCollectionFieldsTraitConfig =
                await getCurrentUserSettingsFieldsTraits(
                  this.get('type'),
                  collectionName,
                  collections,
                  userSettingsCollection,
                );
              const currentSubTenantCollectionFieldsTraitConfig =
                await getCurrentSubTenantFieldsTraits(
                  this.get('type'),
                  collectionName,
                  collections,
                  subTenantCollection,
                );
              if (trait) {
                if (!collectionFieldTrait) {
                  this.addTrait(trait, { at: 0 });
                }
                const inputField = this.get('traits').where({ type: 'input-field' })[0];
                const options = inputField.get('options');
                const selectedValue = options.find((opt) => {
                  if (opt.id !== '') {
                    const optIdValue = opt.id;
                    const optIdValueString = optIdValue
                      ? optIdValue.replaceAll("'", '"').replaceAll('\\"', '"')
                      : '';
                    const optIdValueJson = optIdValueString ? JSON.parse(optIdValueString) : '';
                    return optIdValueJson.fieldName === this.getAttributes()['name'];
                  }
                });
                /**
                 * This is related to reference field collection
                 */
                if (selectedValue && selectedValue.id) {
                  let pageCollOpts = pageCollection ? pageCollection.options : [];
                  pageCollOpts = pageCollOpts.filter((opt) =>
                    [...pageCollectionFields, ...BelongsToReferenceField].includes(opt.type),
                  );
                  const selectedValueId = selectedValue.id;
                  const selectedValueIdString = selectedValueId
                    ? selectedValueId.replaceAll("'", '"').replaceAll('\\"', '"')
                    : '';
                  const selectedValueIdJson = selectedValueIdString
                    ? JSON.parse(selectedValueIdString)
                    : '';
                  const { type, refCollection } = selectedValueIdJson ? selectedValueIdJson : '';
                  const collectionName = refCollection ? refCollection.collectionName : '';
                  if (collectionName) {
                    const refCollectionDetail = await getCollectionFields(
                      collectionName,
                      collections,
                    );
                    const { finders } = refCollectionDetail || '';
                    const finderOptions =
                      finders &&
                      finders.map((finder) => {
                        return { value: finder.uuid, name: finder.name };
                      });

                    this.addTrait({
                      type: 'select',
                      label: 'Get Dropdown Data From',
                      name: 'getDropdownDataFrom',
                      options: [
                        { id: 'NONE', name: 'None' },
                        { id: 'FILTER', name: 'Filter (Default)' },
                        { id: 'CURRENT_USER', name: 'Current Logged In User' },
                        { id: 'CURRENT_TENANT', name: 'Current Logged In Tenant' },
                        { id: 'CURRENT_USER_SETTINGS', name: 'Current Logged In User Settings' },
                        { id: 'CURRENT_SUB_TENANT', name: 'Current Logged In Sub Tenant' },
                      ],
                      value: dropdownDataFromValue,
                      changeProp: 1,
                    });

                    const currentUserCollectionFieldTrait = this.getTrait(
                      'currentUserCollectionField',
                    );
                    const currentTenantCollectionFieldTrait = this.getTrait(
                      'currentTenantCollectionField',
                    );
                    const currentUserSettingsCollectionFieldTrait = this.getTrait(
                      'currentUserSettingsCollectionField',
                    );
                    const currentSubTenantCollectionFieldTrait = this.getTrait(
                      'currentSubTenantCollectionField',
                    );
                    switch (dropdownDataFromValue) {
                      case 'NONE':
                        if (finderUuid) {
                          this.removeTrait('finderUuid');
                        }
                        if (currentUserCollectionFieldTrait) {
                          this.removeTrait('currentUserCollectionField');
                        }
                        if (currentTenantCollectionFieldTrait) {
                          this.removeTrait('currentTenantCollectionField');
                        }
                        if (currentUserSettingsCollectionFieldTrait) {
                          this.removeTrait('currentUserSettingsCollectionField');
                        }
                        if (currentSubTenantCollectionFieldTrait) {
                          this.removeTrait('currentSubTenantCollectionField');
                        }
                        break;
                      case 'CURRENT_USER':
                        if (finderUuid) {
                          this.removeTrait('finderUuid');
                        }
                        if (currentTenantCollectionFieldTrait) {
                          this.removeTrait('currentTenantCollectionField');
                        }
                        if (currentUserSettingsCollectionFieldTrait) {
                          this.removeTrait('currentUserSettingsCollectionField');
                        }
                        if (currentSubTenantCollectionFieldTrait) {
                          this.removeTrait('currentSubTenantCollectionField');
                        }
                        if (!currentUserCollectionFieldTrait) {
                          if (currentUserCollectionFieldsTraitConfig) {
                            this.addTrait(currentUserCollectionFieldsTraitConfig, {
                              at: this.getTraitIndex('getDropdownDataFrom') + 1,
                            });
                          }
                        }
                        break;
                      case 'CURRENT_TENANT':
                        if (finderUuid) {
                          this.removeTrait('finderUuid');
                        }
                        if (currentUserCollectionFieldTrait) {
                          this.removeTrait('currentUserCollectionField');
                        }
                        if (currentUserSettingsCollectionFieldTrait) {
                          this.removeTrait('currentUserSettingsCollectionField');
                        }
                        if (currentSubTenantCollectionFieldTrait) {
                          this.removeTrait('currentSubTenantCollectionField');
                        }
                        if (!currentTenantCollectionFieldTrait) {
                          if (currentTenantCollectionFieldsTraitConfig) {
                            this.addTrait(currentTenantCollectionFieldsTraitConfig, {
                              at: this.getTraitIndex('getDropdownDataFrom') + 1,
                            });
                          }
                        }
                        break;
                      case 'CURRENT_USER_SETTINGS':
                        if (finderUuid) {
                          this.removeTrait('finderUuid');
                        }
                        if (currentUserCollectionFieldTrait) {
                          this.removeTrait('currentUserCollectionField');
                        }
                        if (currentTenantCollectionFieldTrait) {
                          this.removeTrait('currentTenantCollectionField');
                        }
                        if (currentSubTenantCollectionFieldTrait) {
                          this.removeTrait('currentSubTenantCollectionField');
                        }
                        if (!currentUserSettingsCollectionFieldTrait) {
                          if (currentUserSettingsCollectionFieldsTraitConfig) {
                            this.addTrait(currentUserSettingsCollectionFieldsTraitConfig, {
                              at: this.getTraitIndex('getDropdownDataFrom') + 1,
                            });
                          }
                        }
                        break;
                      case 'CURRENT_SUB_TENANT':
                        if (finderUuid) {
                          this.removeTrait('finderUuid');
                        }
                        if (currentUserCollectionFieldTrait) {
                          this.removeTrait('currentUserCollectionField');
                        }
                        if (currentTenantCollectionFieldTrait) {
                          this.removeTrait('currentTenantCollectionField');
                        }
                        if (currentUserSettingsCollectionFieldTrait) {
                          this.removeTrait('currentUserSettingsCollectionField');
                        }
                        if (!currentSubTenantCollectionFieldTrait) {
                          if (currentSubTenantCollectionFieldsTraitConfig) {
                            this.addTrait(currentSubTenantCollectionFieldsTraitConfig, {
                              at: this.getTraitIndex('getDropdownDataFrom') + 1,
                            });
                          }
                        }
                        break;
                      default:
                        if (!finderUuid) {
                          const findAllFinder =
                            finders &&
                            finders.find(
                              (finder) => finder.name === 'Find All' || finder.name === 'All Items',
                            ).uuid;
                          if (findAllFinder) {
                            this.set('finderUuid', findAllFinder);
                          }
                        }

                        this.addTrait(
                          {
                            type: 'select',
                            label: 'filter',
                            name: 'finderUuid',
                            options: finderOptions,
                            value: finderUuid,
                            changeProp: 1,
                          },
                          { at: this.getTraitIndex('getDropdownDataFrom') + 1 },
                        );
                        break;
                    }
                    const selectedFinder =
                      finders && finders.find((currentFinder) => currentFinder.uuid === finderUuid);
                    if (selectedFinder && selectedFinder.noOfExternalParams > 0) {
                      const externalQueryParamKeys = [];
                      if (selectedFinder.conditions) {
                        selectedFinder.conditions.forEach((condition) => {
                          if (condition.requiredExternal) {
                            const {
                              query: { value },
                            } = condition;
                            if (value.includes('---')) {
                              const values = value.split('---');
                              externalQueryParamKeys.push(values[0]);
                              externalQueryParamKeys.push(values[1]);
                            } else {
                              externalQueryParamKeys.push(value);
                            }
                          }
                        });
                      }
                      if (externalQueryParamKeys.length > 0) {
                        externalQueryParamKeys.forEach((extParam) => {
                          this.addTrait({
                            name: extParam,
                            label: extParam,
                            options: pageCollOpts,
                            title: extParam,
                            type: 'finder-query-param-trait',
                          });
                        });
                      }
                    }
                  }
                  let valueToSet = JSON.stringify(selectedValue.id);
                  valueToSet = valueToSet.substr(1, valueToSet.length - 2);
                  this.set('collectionField', `${valueToSet}`);
                }
                /**
                 * This is own collection field
                 */

                const collectionDetail = await getCollectionFields(collectionName, collections);
                const workflows = collectionDetail ? collectionDetail.workflows : [];
                const defaultOption = { value: '', name: '- Select One -' };
                const wOptions = workflows.map((workflow) => {
                  return { value: workflow.uuid, name: workflow.name };
                });
                const workflowOptions = [defaultOption, ...wOptions];
                this.addTrait({
                  type: 'select',
                  label: 'workflow',
                  name: 'workflowUuid',
                  options: workflowOptions,
                  changeProp: 1,
                });
              }
            }
          }

          this.on('change:collectionName', this.handleCollectionChange);
          this.on('change:collectionField', this.handleCollectionFieldChange);
          this.on('change:finderUuid', this.handleFinderChange);
          this.on('change:getDropdownDataFrom', this.handleGetDropDownDataFromChange);
          this.on('change:currentUserCollectionField', this.handleUserCollectionFieldChange);
          this.on('change:currentTenantCollectionField', this.handleTenantCollectionFieldChange);
          this.on(
            'change:currentUserSettingsCollectionField',
            this.handleUserSettingsCollectionFieldChange,
          );
          this.on(
            'change:currentSubTenantCollectionField',
            this.handleSubTenantCollectionFieldChange,
          );
        },
        async handleFinderChange() {
          const finderUuid = this.get('finderUuid');
          const attrs = this.getAttributes();
          if (finderUuid) {
            attrs['data-select-finder-id'] = finderUuid;
          } else {
            delete attrs['data-select-finder-id'];
          }
          delete attrs['data-select-external-params'];
          const allTraits = this.get('traits');
          const removeTraits = [];
          allTraits.forEach((trait) => {
            if (trait.props().type === 'finder-query-param-trait') {
              removeTraits.push(trait.props().name);
            }
          });
          removeTraits.map((trait) => this.removeTrait(trait));
          const inputField = this.get('traits').where({ type: 'input-field' })[0];
          const options = inputField.get('options');
          const selectedValue = options.find((opt) => {
            if (opt.id !== '') {
              const optIdValue = opt.id;
              const optIdValueString = optIdValue
                ? optIdValue.replaceAll("'", '"').replaceAll('\\"', '"')
                : '';
              const optIdValueJson = optIdValueString ? JSON.parse(optIdValueString) : '';
              return optIdValueJson.fieldName === this.getAttributes()['name'];
            }
          });
          if (selectedValue && selectedValue.id) {
            let pageCollOpts = pageCollection ? pageCollection.options : [];
            pageCollOpts = pageCollOpts.filter((opt) =>
              [...pageCollectionFields, ...BelongsToReferenceField].includes(opt.type),
            );
            const selectedValueId = selectedValue.id;
            const selectedValueIdString = selectedValueId
              ? selectedValueId.replaceAll("'", '"').replaceAll('\\"', '"')
              : '';
            const selectedValueIdJson = selectedValueIdString
              ? JSON.parse(selectedValueIdString)
              : '';

            const {
              type,
              refCollection: { collectionName },
            } = selectedValueIdJson ? selectedValueIdJson : '';
            if (collectionName) {
              const refCollectionDetail = await getCollectionFields(collectionName, collections);
              const { finders } = refCollectionDetail;
              const selectedFinder = finders.find((cf) => cf.uuid === finderUuid);
              if (!finderUuid && selectedFinder) {
                this.set('finderUuid', selectedFinder.uuid);
              }

              if (selectedFinder && selectedFinder.noOfExternalParams > 0) {
                const externalQueryParamKeys = [];
                if (selectedFinder.conditions) {
                  selectedFinder.conditions.forEach((condition) => {
                    if (condition.requiredExternal) {
                      const {
                        query: { value },
                      } = condition;
                      if (value.includes('---')) {
                        const values = value.split('---');
                        externalQueryParamKeys.push(values[0]);
                        externalQueryParamKeys.push(values[1]);
                      } else {
                        externalQueryParamKeys.push(value);
                      }
                    }
                  });
                }
                if (externalQueryParamKeys.length > 0) {
                  externalQueryParamKeys.forEach((extParam) => {
                    this.addTrait({
                      name: extParam,
                      label: extParam,
                      options: pageCollOpts,
                      title: extParam,
                      type: 'finder-query-param-trait',
                    });
                  });
                  attrs['data-select-external-params'] = externalQueryParamKeys.join(',');
                }
              }
            }
          }
          this.setAttributes(attrs);
        },
        async handleCollectionChange() {
          const collectionName = this.get('collectionName');
          this.removeTrait(['fieldName']);
          if (collectionName) {
            let collection = collections.find((coll) => coll.collectionName === collectionName);
            if (collection) {
              const fieldOptions = getFieldsTraitsOptionsForAutocomplete(collection.fields);
              this.addTrait([
                {
                  type: 'select',
                  label: 'Field',
                  name: 'fieldName',
                  changeProp: 1,
                  options: fieldOptions,
                },
              ]);
            }
          }
        },
        async handleGetDropDownDataFromChange() {
          const dropdownDataFrom = this.get('getDropdownDataFrom');
          if (dropdownDataFrom) {
            let finderUuidTrait = this.getTrait('finderUuid');
            const currentUserCollectionFieldTrait = this.getTrait('currentUserCollectionField');
            const currentTenantCollectionFieldTrait = this.getTrait('currentTenantCollectionField');
            const currentUserSettingsCollectionFieldTrait = this.getTrait(
              'currentUserSettingsCollectionField',
            );
            const currentSubTenantCollectionFieldTrait = this.getTrait(
              'currentSubTenantCollectionField',
            );
            switch (dropdownDataFrom) {
              case 'NONE':
                if (finderUuidTrait) {
                  this.set('finderUuid', '');
                  this.removeTrait('finderUuid');
                }
                if (currentUserCollectionFieldTrait) {
                  this.set('currentUserCollectionField', '');
                  this.removeTrait('currentUserCollectionField');
                }
                if (currentTenantCollectionFieldTrait) {
                  this.set('currentTenantCollectionField', '');
                  this.removeTrait('currentTenantCollectionField');
                }
                if (currentUserSettingsCollectionFieldTrait) {
                  this.set('currentUserSettingsCollectionField', '');
                  this.removeTrait('currentUserSettingsCollectionField');
                }
                if (currentSubTenantCollectionFieldTrait) {
                  this.set('currentSubTenantCollectionField', '');
                  this.removeTrait('currentSubTenantCollectionField');
                }
                break;
              case 'CURRENT_USER':
                if (finderUuidTrait) {
                  this.set('finderUuid', '');
                  this.removeTrait('finderUuid');
                }
                if (currentTenantCollectionFieldTrait) {
                  this.set('currentTenantCollectionField', '');
                  this.removeTrait('currentTenantCollectionField');
                }
                if (currentUserSettingsCollectionFieldTrait) {
                  this.set('currentUserSettingsCollectionField', '');
                  this.removeTrait('currentUserSettingsCollectionField');
                }
                if (currentSubTenantCollectionFieldTrait) {
                  this.set('currentSubTenantCollectionField', '');
                  this.removeTrait('currentSubTenantCollectionField');
                }
                let collectionForm =
                  this.closestType('collection-form') ||
                  this.closestType('sign-up-form') ||
                  this.closestType('search-form') ||
                  this.closestType('survey-form-field');
                if (collectionForm) {
                  const collectionName = collectionForm.getAttributes()['data-form-collection'];
                  if (collectionName) {
                    const currentUserCollectionFieldsTraitConfig = await getCurrentUserFieldsTraits(
                      this.get('type'),
                      collectionName,
                      collections,
                    );
                    if (!currentUserCollectionFieldTrait) {
                      this.addTrait(currentUserCollectionFieldsTraitConfig, {
                        at: this.getTraitIndex('getDropdownDataFrom') + 1,
                      });
                    }
                  }
                }
                break;
              case 'CURRENT_TENANT':
                if (finderUuidTrait) {
                  this.set('finderUuid', '');
                  this.removeTrait('finderUuid');
                }
                if (currentUserCollectionFieldTrait) {
                  this.set('currentUserCollectionField', '');
                  this.removeTrait('currentUserCollectionField');
                }
                if (currentUserSettingsCollectionFieldTrait) {
                  this.set('currentUserSettingsCollectionField', '');
                  this.removeTrait('currentUserSettingsCollectionField');
                }
                if (currentSubTenantCollectionFieldTrait) {
                  this.set('currentSubTenantCollectionField', '');
                  this.removeTrait('currentSubTenantCollectionField');
                }
                let collectionTenantForm =
                  this.closestType('collection-form') ||
                  this.closestType('sign-up-form') ||
                  this.closestType('search-form') ||
                  this.closestType('survey-form-field');
                if (collectionTenantForm) {
                  const collectionName =
                    collectionTenantForm.getAttributes()['data-form-collection'];
                  if (collectionName) {
                    const currentTenantCollectionFieldsTraitConfig =
                      await getCurrentTenantFieldsTraits(
                        this.get('type'),
                        collectionName,
                        collections,
                        multiTenantCollection,
                      );
                    if (!currentTenantCollectionFieldTrait) {
                      this.addTrait(currentTenantCollectionFieldsTraitConfig, {
                        at: this.getTraitIndex('getDropdownDataFrom') + 1,
                      });
                    }
                  }
                }
                break;
              case 'CURRENT_USER_SETTINGS':
                if (finderUuidTrait) {
                  this.set('finderUuid', '');
                  this.removeTrait('finderUuid');
                }
                if (currentUserCollectionFieldTrait) {
                  this.set('currentUserCollectionField', '');
                  this.removeTrait('currentUserCollectionField');
                }
                if (currentTenantCollectionFieldTrait) {
                  this.set('currentTenantCollectionField', '');
                  this.removeTrait('currentTenantCollectionField');
                }
                if (currentSubTenantCollectionFieldTrait) {
                  this.set('currentSubTenantCollectionField', '');
                  this.removeTrait('currentSubTenantCollectionField');
                }
                let collectionUserSettingForm =
                  this.closestType('collection-form') ||
                  this.closestType('sign-up-form') ||
                  this.closestType('search-form') ||
                  this.closestType('survey-form-field');
                if (collectionUserSettingForm) {
                  const collectionName =
                    collectionUserSettingForm.getAttributes()['data-form-collection'];
                  if (collectionName) {
                    const currentUserSettingsCollectionFieldsTraitConfig =
                      await getCurrentUserSettingsFieldsTraits(
                        this.get('type'),
                        collectionName,
                        collections,
                        userSettingsCollection,
                      );
                    if (!currentUserSettingsCollectionFieldTrait) {
                      this.addTrait(currentUserSettingsCollectionFieldsTraitConfig, {
                        at: this.getTraitIndex('getDropdownDataFrom') + 1,
                      });
                    }
                  }
                }
                break;
              case 'CURRENT_SUB_TENANT':
                if (finderUuidTrait) {
                  this.set('finderUuid', '');
                  this.removeTrait('finderUuid');
                }
                if (currentUserCollectionFieldTrait) {
                  this.set('currentUserCollectionField', '');
                  this.removeTrait('currentUserCollectionField');
                }
                if (currentTenantCollectionFieldTrait) {
                  this.set('currentTenantCollectionField', '');
                  this.removeTrait('currentTenantCollectionField');
                }
                if (currentUserSettingsCollectionFieldTrait) {
                  this.set('currentUserSettingsCollectionField', '');
                  this.removeTrait('currentUserSettingsCollectionField');
                }
                let collectionSubTenantForm =
                  this.closestType('collection-form') ||
                  this.closestType('sign-up-form') ||
                  this.closestType('search-form') ||
                  this.closestType('survey-form-field');
                if (collectionSubTenantForm) {
                  const collectionName =
                    collectionSubTenantForm.getAttributes()['data-form-collection'];
                  if (collectionName) {
                    const currentSubTenantCollectionFieldsTraitConfig =
                      await getCurrentSubTenantFieldsTraits(
                        this.get('type'),
                        collectionName,
                        collections,
                        subTenantCollection,
                      );
                    if (!currentSubTenantCollectionFieldTrait) {
                      this.addTrait(currentSubTenantCollectionFieldsTraitConfig, {
                        at: this.getTraitIndex('getDropdownDataFrom') + 1,
                      });
                    }
                  }
                }
                break;
              default:
                if (currentUserCollectionFieldTrait) {
                  this.set('currentUserCollectionField', '');
                  this.removeTrait('currentUserCollectionField');
                }
                if (currentTenantCollectionFieldTrait) {
                  this.set('currentTenantCollectionField', '');
                  this.removeTrait('currentTenantCollectionField');
                }
                if (currentUserSettingsCollectionFieldTrait) {
                  this.set('currentUserSettingsCollectionField', '');
                  this.removeTrait('currentUserSettingsCollectionField');
                }
                if (currentSubTenantCollectionFieldTrait) {
                  this.set('currentSubTenantCollectionField', '');
                  this.removeTrait('currentSubTenantCollectionField');
                }
                if (!finderUuidTrait) {
                  let collectionForm =
                    this.closestType('collection-form') ||
                    this.closestType('sign-up-form') ||
                    this.closestType('search-form') ||
                    this.closestType('survey-form-field');
                  if (collectionForm) {
                    const collectionName = collectionForm.getAttributes()['data-form-collection'];
                    if (collectionName) {
                      const trait = await getFieldsTraits(
                        this.get('type'),
                        collectionName,
                        collections,
                      );
                      const collectionFieldTrait = this.getTrait('collectionField');
                      if (trait) {
                        if (!collectionFieldTrait) {
                          this.addTrait(trait, { at: 0 });
                        }
                        const inputField = this.get('traits').where({ type: 'input-field' })[0];
                        const options = inputField.get('options');
                        const selectedValue = options.find((opt) => {
                          if (opt.id !== '') {
                            const optIdValue = opt.id;
                            const optIdValueString = optIdValue
                              ? optIdValue.replaceAll("'", '"').replaceAll('\\"', '"')
                              : '';
                            const optIdValueJson = optIdValueString
                              ? JSON.parse(optIdValueString)
                              : '';
                            return optIdValueJson.fieldName === this.getAttributes()['name'];
                          }
                        });
                        if (selectedValue && selectedValue.id) {
                          const selectedValueId = selectedValue.id;
                          const selectedValueIdString = selectedValueId
                            ? selectedValueId.replaceAll("'", '"').replaceAll('\\"', '"')
                            : '';
                          const selectedValueIdJson = selectedValueIdString
                            ? JSON.parse(selectedValueIdString)
                            : '';
                          const {
                            type,
                            refCollection: { collectionName },
                          } = selectedValueIdJson ? selectedValueIdJson : '';
                          if (collectionName) {
                            const refCollectionDetail = await getCollectionFields(
                              collectionName,
                              collections,
                            );
                            const { finders } = refCollectionDetail;
                            const finderOptions = finders.map((finder) => {
                              return { value: finder.uuid, name: finder.name };
                            });
                            const findAllFinder = finders.find(
                              (finder) => finder.name === 'Find All' || finder.name === 'All Items',
                            ).uuid;
                            this.addTrait(
                              {
                                type: 'select',
                                label: 'filter',
                                name: 'finderUuid',
                                options: finderOptions,
                                changeProp: 1,
                              },
                              { at: this.getTraitIndex('getDropdownDataFrom') + 1 },
                            );
                            if (findAllFinder) {
                              this.set('finderUuid', findAllFinder);
                            }
                          }
                        }
                      }
                    }
                  }
                }
                break;
            }
          }
        },
        async handleCollectionFieldChange() {
          const collectionField = this.get('collectionField');
          let finderUuidTrait = this.getTrait('finderUuid');
          if (finderUuidTrait) {
            this.removeTrait('finderUuid');
          }

          const inputField = this.get('traits').where({ type: 'input-field' })[0];
          const options = inputField.get('options');
          const selectedValue = options.find((opt) => {
            if (opt.id !== '') {
              const optIdValue = opt.id;
              const optIdValueString = optIdValue
                ? optIdValue.replaceAll("'", '"').replaceAll('\\"', '"')
                : '';
              const optIdValueJson = optIdValueString ? JSON.parse(optIdValueString) : '';
              return optIdValueJson.fieldName === this.getAttributes()['name'];
            }
          });

          if (selectedValue && selectedValue.id) {
            const selectedValueId = selectedValue.id;
            const selectedValueIdString = selectedValueId
              ? selectedValueId.replaceAll("'", '"').replaceAll('\\"', '"')
              : '';
            const selectedValueIdJson = selectedValueIdString
              ? JSON.parse(selectedValueIdString)
              : '';
            const {
              type,
              refCollection: { collectionName },
            } = selectedValueIdJson ? selectedValueIdJson : '';
            const currentUserCollectionFieldTrait = this.getTrait('currentUserCollectionField');
            const currentTenantCollectionFieldTrait = this.getTrait('currentTenantCollectionField');
            const currentUserSettingsCollectionFieldTrait = this.getTrait(
              'currentUserSettingsCollectionField',
            );
            const currentSubTenantCollectionFieldTrait = this.getTrait(
              'currentSubTenantCollectionField',
            );
            if (
              currentUserCollectionFieldTrait ||
              currentTenantCollectionFieldTrait ||
              currentUserSettingsCollectionFieldTrait ||
              currentSubTenantCollectionFieldTrait
            ) {
              if (currentUserCollectionFieldTrait) {
                this.set('currentUserCollectionField', '');
                this.removeTrait('currentUserCollectionField');
              }
              if (currentTenantCollectionFieldTrait) {
                this.set('currentTenantCollectionField', '');
                this.removeTrait('currentTenantCollectionField');
              }
              if (currentUserSettingsCollectionFieldTrait) {
                this.set('currentUserSettingsCollectionField', '');
                this.removeTrait('currentUserSettingsCollectionField');
              }
              if (currentSubTenantCollectionFieldTrait) {
                this.set('currentSubTenantCollectionField', '');
                this.removeTrait('currentSubTenantCollectionField');
              }
              const getDropdownDataFromTrait = this.getTrait('getDropdownDataFrom');
              if (getDropdownDataFromTrait) {
                const getDropdownDataFromTraitIndex = this.getTraitIndex('getDropdownDataFrom');
                this.set('getDropdownDataFrom', '');
                this.removeTrait('getDropdownDataFrom');
                this.set('getDropdownDataFrom', 'FILTER');
                this.addTrait(
                  {
                    type: 'select',
                    label: 'Get Dropdown Data From',
                    name: 'getDropdownDataFrom',
                    options: [
                      // Array of options
                      { id: 'NONE', name: 'None' },
                      { id: 'FILTER', name: 'Filter (Default)' },
                      { id: 'CURRENT_USER', name: 'Current Logged In User' },
                      { id: 'CURRENT_TENANT', name: 'Current Logged In Tenant' },
                      { id: 'CURRENT_USER_SETTINGS', name: 'Current Logged In User Settings' },
                      { id: 'CURRENT_SUB_TENANT', name: 'Current Logged In Sub Tenant' },
                    ],
                    changeProp: 1,
                  },
                  { at: getDropdownDataFromTraitIndex },
                );
              }
            }

            if (collectionName) {
              const refCollectionDetail = await getCollectionFields(collectionName, collections);
              const { finders } = refCollectionDetail;
              const finderOptions = finders.map((finder) => {
                return { value: finder.uuid, name: finder.name };
              });

              const findAllFinder = finders.find(
                (finder) => finder.name === 'Find All' || finder.name === 'All Items',
              ).uuid;

              const finderUuidTrait = this.getTrait('finderUuid');
              if (!finderUuidTrait) {
                this.addTrait(
                  {
                    type: 'select',
                    label: 'filter',
                    name: 'finderUuid',
                    options: finderOptions,
                    changeProp: 1,
                  },
                  { at: this.getTraitIndex('getDropdownDataFrom') + 1 },
                );
              }
              if (findAllFinder) {
                this.set('finderUuid', findAllFinder);
              }
            }
            let valueToSet = JSON.stringify(selectedValue.id);
            valueToSet = valueToSet.substr(1, valueToSet.length - 2);
            this.set('collectionField', `${valueToSet}`);
          }
        },
        async handleUserCollectionFieldChange() {
          const currentUserCollectionFieldValue = this.get('currentUserCollectionField');
          const currentUserCollectionFieldString = currentUserCollectionFieldValue
            ? currentUserCollectionFieldValue.replaceAll("'", '"').replaceAll('\\"', '"')
            : '';
          if (currentUserCollectionFieldString) {
            let valueToSet = JSON.stringify(currentUserCollectionFieldString);
            valueToSet = valueToSet.substr(1, valueToSet.length - 2);
            this.set('currentUserCollectionField', `${valueToSet}`);
          }
        },
        async handleTenantCollectionFieldChange() {
          const currentTenantCollectionFieldValue = this.get('currentTenantCollectionField');
          const currentTenantCollectionFieldString = currentTenantCollectionFieldValue
            ? currentTenantCollectionFieldValue.replaceAll("'", '"').replaceAll('\\"', '"')
            : '';
          if (currentTenantCollectionFieldString) {
            let valueToSet = JSON.stringify(currentTenantCollectionFieldString);
            valueToSet = valueToSet.substr(1, valueToSet.length - 2);
            this.set('currentTenantCollectionField', `${valueToSet}`);
          }
        },
        async handleUserSettingsCollectionFieldChange() {
          const currentUserSettingsCollectionFieldValue = this.get(
            'currentUserSettingsCollectionField',
          );
          const currentUserSettingsCollectionFieldString = currentUserSettingsCollectionFieldValue
            ? currentUserSettingsCollectionFieldValue.replaceAll("'", '"').replaceAll('\\"', '"')
            : '';
          if (currentUserSettingsCollectionFieldString) {
            let valueToSet = JSON.stringify(currentUserSettingsCollectionFieldString);
            valueToSet = valueToSet.substr(1, valueToSet.length - 2);
            this.set('currentUserSettingsCollectionField', `${valueToSet}`);
          }
        },
        async handleSubTenantCollectionFieldChange() {
          const currentSubTenantCollectionFieldValue = this.get('currentSubTenantCollectionField');
          const currentSubTenantCollectionFieldString = currentSubTenantCollectionFieldValue
            ? currentSubTenantCollectionFieldValue.replaceAll("'", '"').replaceAll('\\"', '"')
            : '';
          if (currentSubTenantCollectionFieldString) {
            let valueToSet = JSON.stringify(currentSubTenantCollectionFieldString);
            valueToSet = valueToSet.substr(1, valueToSet.length - 2);
            this.set('currentSubTenantCollectionField', `${valueToSet}`);
          }
        },
      },
      {
        isComponent(el) {
          if (el.tagName === 'SELECT') {
            return { type: 'select' };
          } else {
          }
        },
      },
    ),
    view: defaultView.extend({
      events: {
        submit(e) {
          e.preventDefault();
        },
      },
      init({ model }) {
        this.listenTo(model, 'change:workflowUuid', this.updateScript);
      },
    }),
  });
  domc.addType('radio', {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          droppable: ':not(form)',
          draggable: ':not(form)',
          projectId: projectId,
          version: version,
          traits: [
            {
              type: 'form-element-trait',
              label: false,
              name: 'data-element-field-name',
              customLabel: 'Get Value From',
              content: false,
            },
          ].concat(domc.getType('radio').model.prototype.defaults.traits),
          script: function () {
            let collectionField = '{[ collectionField ]}';
            let finderUuid = '{[ finderUuid ]}';
            let workflowUuid = '{[ workflowUuid ]}';
            let dataSearchForm = this.closest('.search-form');

            let formEl = this.closest('form');
            let isModal = false;
            const isModalForm = formEl && formEl.closest('[id^=modal-container]');
            isModal = isModalForm ? true : false;

            if (isModal) {
              formEl.setAttribute('data-form-modal', true);
              this.setAttribute('data-collection-field', collectionField);
            }

            if (dataSearchForm) {
              if (typeof loadSearchFormDynamicSelectOptions !== 'undefined') {
                loadSearchFormDynamicSelectOptions(this, collectionField, finderUuid);
              }
            } else {
              if (typeof loadDynamicSelectOptionsForRadio !== 'undefined') {
                loadDynamicSelectOptionsForRadio(this, collectionField, finderUuid, workflowUuid);
              }
            }
          },
        },
        init() {
          let collectionForm = this.closestType('collection-form');
          collectionForm = collectionForm
            ? collectionForm
            : this.closestType('sign-up-form')
            ? this.closestType('sign-up-form')
            : this.closestType('search-form');
          if (collectionForm && collectionForm.getAttributes()['data-form-collection']) {
            const updateTraits = this.get('traits').models.filter((trait) => {
              return trait.get('type') !== 'select-options';
            });
            this.set('traits', updateTraits);
            getFieldsTraits(
              this.get('type'),
              collectionForm.getAttributes()['data-form-collection'],
              collections,
            ).then(async (res) => {
              if (res) {
                this.addTrait(res, { at: 0 });
                const inputField = this.get('traits').where({ type: 'input-field' })[0];
                const options = inputField.get('options');
                const selectedValue = options.find((opt) => {
                  if (opt.id !== '') {
                    return JSON.parse(opt.id).fieldName === this.getAttributes()['name'];
                  }
                });
                if (selectedValue && selectedValue.id) {
                  const {
                    type,
                    refCollection: { collectionName },
                  } = JSON.parse(selectedValue.id);
                  if (collectionName) {
                    const refCollectionDetail = await getCollectionFields(
                      collectionName,
                      collections,
                    );

                    const { finders } = refCollectionDetail;
                    const finderOptions = finders.map((finder) => {
                      return { value: finder.uuid, name: finder.name };
                    });
                    console.log('=> Collection refCollectionDetail :>> ', refCollectionDetail);
                    this.addTrait({
                      type: 'select',
                      label: 'filter',
                      name: 'finderUuid',
                      options: finderOptions,
                      changeProp: 1,
                    });
                  }

                  let valueToSet = JSON.stringify(selectedValue.id);
                  valueToSet = valueToSet.substr(1, valueToSet.length - 2);
                  this.set('collectionField', `${valueToSet}`);
                }

                if (collectionForm.getAttributes()['data-form-collection']) {
                  const collectionName = collectionForm.getAttributes()['data-form-collection'];
                  const collectionDetail = await getCollectionFields(collectionName, collections);
                  console.log('=> Field select collectionDetail :>> ', collectionDetail);
                  const { workflows } = collectionDetail;
                  console.log('=> Collection Field collectionDetail workflows :>> ', workflows);
                  const defaultOption = { value: '', name: '- Select One -' };
                  const options = workflows.map((workflow) => {
                    return { value: workflow.uuid, name: workflow.name };
                  });
                  const workflowOptions = [defaultOption, ...options];
                  console.log('==> Select collectionDetail workflowOptions :>> ', workflowOptions);
                  this.addTrait({
                    type: 'select',
                    label: 'workflow',
                    name: 'workflowUuid',
                    options: workflowOptions,
                    changeProp: 1,
                  });
                }
              }
            });
          }
          this.on('change:finderUuid', this.handleFinderChange);
        },
        async handleFinderChange() {
          const finderUuid = this.get('finderUuid');
          const attrs = this.getAttributes();
          if (finderUuid) {
            attrs['data-select-finder-id'] = finderUuid;
          } else {
            delete attrs['data-select-finder-id'];
          }
          this.setAttributes(attrs);
        },
      },
      {
        isComponent(el) {
          if (el.tagName === 'INPUT' && el.type === 'radio') {
            return { type: 'radio' };
          } else {
          }
        },
      },
    ),
    view: defaultView.extend({
      events: {
        submit(e) {
          e.preventDefault();
        },
      },
      init({ model }) {
        this.listenTo(model, 'change:collectionField', this.updateScript);
        this.listenTo(model, 'change:finderUuid', this.updateScript);
        this.listenTo(model, 'change:workflowUuid', this.updateScript);
      },
    }),
  });
  domc.addType('collection-file-dropzone', {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          name: labelColFileDropzone,
          droppable: false,
          draggable: ':not(form)',
          projectId: projectId,
          icon: '<i class="wb webconnect-file-arrow-up"></i>',
          traits: [
            {
              type: 'checkbox',
              label: 'Required',
              name: 'dropzoneRequired',
              changeProp: 1,
            },
            {
              type: 'number',
              label: 'Maximum Size (in mb)',
              name: 'dropzoneMaxSize',
              min: 0,
              step: 1,
              max: 500,
              changeProp: 1,
            },
          ].concat(domc.getType('default').model.prototype.defaults.traits),
          script: function () {
            let collectionFieldName = '{[ collectionFieldName ]}';
            let collectionFieldTitle = '{[ collectionFieldTitle ]}';
            let fieldValidationMin = '{[ fieldValidationMin ]}';
            let fieldValidationMax = '{[ fieldValidationMax ]}';
            let fieldValidationRegex = '{[ fieldValidationRegex ]}';
            let fieldValidationNoAllowedFiles = '{[ fieldValidationNoAllowedFiles ]}';
            let fieldValidationAllowedFileTypes = '{[ fieldValidationAllowedFileTypes ]}';
            let isPrivate = '{[ isPrivate ]}';
            let isEncrypted = '{[ isEncrypted ]}';
            let isFileTrackerPluginInstalled = '{[ isFileTrackerPluginInstalled ]}';
            let refCollection = '{[ refCollection ]}';
            let refCollectionField = '{[ refCollectionField ]}';
            let dropzoneRequired = '{[ dropzoneRequired ]}';
            let dropzoneMaxSize = '{[ dropzoneMaxSize ]}';
            let dropzoneRequiredErrorMessage = '{[ dropzoneRequiredErrorMessage ]}';
            const getDropZoneDataFrom = '{[ getDropZoneDataFrom ]}';
            const formCollectionField = '{[ formCollectionField ]}';
            const currentUserField = '{[ currentUserCollectionField ]}';
            const currentTenantField = '{[ currentTenantCollectionField ]}';
            const currentUserSettingsField = '{[ currentUserSettingsCollectionField ]}';
            const currentSubTenantField = '{[ currentSubTenantCollectionField ]}';

            if (collectionFieldName && collectionFieldTitle) {
              let collectionFieldData = {
                name: collectionFieldName,
                title: collectionFieldTitle,
                isPrivate: isPrivate,
                isEncrypted: isEncrypted,
                validation: {
                  min: fieldValidationMin,
                  max: fieldValidationMax,
                  regex: fieldValidationRegex,
                  noAllowedFiles: fieldValidationNoAllowedFiles,
                  allowedFileTypes: fieldValidationAllowedFileTypes,
                },
                refCollection: refCollection,
                refCollectionField: refCollectionField,
                required: dropzoneRequired,
                maxSize: dropzoneMaxSize ? parseFloat(dropzoneMaxSize) : null,
                requiredErrorMessage: dropzoneRequiredErrorMessage,
              };
              const getContentFromData = {
                getDropZoneDataFrom: getDropZoneDataFrom,
                formCollectionField: formCollectionField,
                currentUserField: currentUserField,
                currentTenantField: currentTenantField,
                currentUserSettingsField: currentUserSettingsField,
                currentSubTenantField: currentSubTenantField,
              };

              const tagNameCollectionField = this.tagName;
              const collectionForm = this.closest(
                '[data-js=collection-form], [data-js=sign-up-form]',
              );
              if (typeof loadDropzoneField !== 'undefined' && tagNameCollectionField === 'DIV') {
                loadDropzoneField(
                  this,
                  collectionForm,
                  collectionFieldData,
                  isFileTrackerPluginInstalled,
                  getContentFromData,
                );
              }
            }
          },
        },
        init() {
          let collectionForm = this.closestType('collection-form');
          collectionForm = collectionForm
            ? collectionForm
            : this.closestType('login-form')
            ? this.closestType('login-form')
            : this.closestType('sign-up-form');

          const traits = this.get('traits');
          traits.forEach((trait) => this.removeTrait('')); //To Remove Column Traits Props
          if (collectionForm && collectionForm.getAttributes()['data-form-collection']) {
            getFieldsTraits(
              this.get('type'),
              collectionForm.getAttributes()['data-form-collection'],
              collections,
            ).then((res) => {
              if (res) {
                const collectionFieldTrait = this.getTrait('collectionField');
                if (!collectionFieldTrait) {
                  this.addTrait(res, { at: 0 });
                }
                const inputField = this.get('traits').where({
                  name: 'collectionFormFileDropzone',
                })[0];
                const options = inputField.get('options');
                const selectedValue = options.find((opt) => {
                  if (opt.id !== '') {
                    const optIdValue = opt.id;
                    const optIdValueString = optIdValue
                      ? optIdValue.replaceAll("'", '"').replaceAll('\\"', '"')
                      : '';
                    const optIdValueJson = optIdValueString ? JSON.parse(optIdValueString) : '';
                    return optIdValueJson.fieldName === this.getAttributes()['name'];
                  }
                });
                const selectedCollectionTitle = collections.find(
                  (coll) =>
                    coll.collectionName === collectionForm.getAttributes()['data-form-collection'],
                ).collectionTitle;
                const customLabel = 'Get Value From';
                const getContentFromOptions = [
                  { id: 'NONE', name: '- Get Content -' },
                  { id: 'FORM_COLLECTION', name: `${customLabel} ${selectedCollectionTitle}` },
                  { id: 'CURRENT_USER', name: `${customLabel} Current Logged In User` },
                ];
                if (multiTenantPlugin) {
                  if (multiTenantCollection) {
                    getContentFromOptions.push({
                      id: 'CURRENT_TENANT',
                      name: `${customLabel} Current Logged In Tenant`,
                    });
                  }
                  if (userSettingsCollection) {
                    getContentFromOptions.push({
                      id: 'CURRENT_USER_SETTINGS',
                      name: `${customLabel} Current Logged In User Settings`,
                    });
                  }
                  if (subTenantCollection) {
                    getContentFromOptions.push({
                      id: 'CURRENT_SUB_TENANT',
                      name: `${customLabel} Current Logged In Sub Tenant`,
                    });
                  }
                }
                this.addTrait({
                  type: 'select',
                  label: 'Get Content',
                  name: 'getDropZoneDataFrom',
                  options: getContentFromOptions,
                  changeProp: 1,
                });

                if (selectedValue) {
                  const selectedValueJson = selectedValue.id ? JSON.parse(selectedValue.id) : '';
                  const isFileTrackerPluginInstalled = !!fileActivityTrackerPlugin;
                  const { validation, isPrivate, encrypted, refCollection } = selectedValueJson;
                  const { min, max, regex, noAllowedFiles, allowedFileTypes } = validation;
                  this.set('collectionField', `${selectedValue.id}`);
                  this.set('collectionFormFileDropzone', `${selectedValue.id}`);
                  this.set('collectionFieldName', `${selectedValueJson.fieldName}`);
                  this.set('collectionFieldTitle', `${selectedValueJson.fieldTitle.en}`);
                  this.set('fieldValidationMin', `${min}`);
                  this.set('fieldValidationMax', `${max}`);
                  this.set('fieldValidationRegex', `${regex}`);
                  this.set('fieldValidationNoAllowedFiles', `${noAllowedFiles}`);
                  this.set('fieldValidationAllowedFileTypes', `${allowedFileTypes}`);
                  this.set('isPrivate', `${isPrivate}`);
                  this.set('isEncrypted', `${encrypted}`);
                  this.set('isFileTrackerPluginInstalled', `${isFileTrackerPluginInstalled}`);
                  if (refCollection.isFileType === true) {
                    this.set('refCollection', `${refCollection.collectionName}`);
                    this.set('refCollectionField', `${refCollection.collectionField}`);
                  }
                }
              }
            });
          }
          this.on('change:collectionFormFileDropzone', this.handleCollectionFormUploadFieldChange);
          this.on(
            'change:dropzoneRequired change:dropzoneMaxSize change:dropzoneRequiredErrorMessage',
            this.updateScript,
          );
          this.on('change:dropzoneRequired', this.handleRequiredErrorMessageVisibility);
          this.on('change:getDropZoneDataFrom', this.handleGetDropZoneDataFromChange);
        },

        async handleCollectionFormUploadFieldChange() {
          const collectionForm = this.closestType('collection-form');
          const collectionName = collectionForm
            ? collectionForm.getAttributes()['data-form-collection']
            : '';
          const collectionFormFileDropzoneValue = this.get('collectionFormFileDropzone');
          const collectionFormFileDropzoneValueString = collectionFormFileDropzoneValue
            ? collectionFormFileDropzoneValue.replaceAll("'", '"').replaceAll('\\"', '"')
            : '';
          const collectionField = collectionFormFileDropzoneValueString
            ? JSON.parse(collectionFormFileDropzoneValueString)
            : '';

          if (collectionField) {
            let valueToSet = JSON.stringify(collectionField);
            this.set('collectionField', `${valueToSet}`);
            const isFileTrackerPluginInstalled = !!fileActivityTrackerPlugin;
            const { validation, isPrivate, encrypted, refCollection } = collectionField;
            const { min, max, regex, noAllowedFiles, allowedFileTypes } = validation;

            this.set('collectionFieldName', `${collectionField.fieldName}`);
            this.set('collectionFieldTitle', `${collectionField.fieldTitle.en}`);
            this.set('fieldValidationMin', `${min}`);
            this.set('fieldValidationMax', `${max}`);
            this.set('fieldValidationRegex', `${regex}`);
            this.set('fieldValidationNoAllowedFiles', `${noAllowedFiles}`);
            this.set('fieldValidationAllowedFileTypes', `${allowedFileTypes}`);
            this.set('isPrivate', `${isPrivate}`);
            this.set('isEncrypted', `${encrypted}`);
            this.set('isFileTrackerPluginInstalled', `${isFileTrackerPluginInstalled}`);
            if (refCollection.isFileType === true) {
              this.set('refCollection', `${refCollection.collectionName}`);
              this.set('refCollectionField', `${refCollection.collectionField}`);
            }

            const attrs = this.getAttributes();
            attrs['data-browse'] = `Drag ${
              collectionField.fieldTitle ? collectionField.fieldTitle.en : 'Files'
            } or Click to Browse`;
            attrs['name'] = collectionField.fieldName;
            this.setAttributes(attrs);
          } else {
            this.set('collectionField', '');
            this.set('collectionFormFileDropzone', '');
            this.set('collectionFieldName', '');
            this.set('collectionFieldTitle', '');
            this.set('fieldValidationMin', '');
            this.set('fieldValidationMax', '');
            this.set('fieldValidationRegex', '');
            this.set('fieldValidationNoAllowedFiles', '');
            this.set('fieldValidationAllowedFileTypes', '');
            this.set('isPrivate', '');
            this.set('isEncrypted', '');
            this.set('isFileTrackerPluginInstalled', '');
            if (refCollection.isFileType === true) {
              this.set('refCollection', '');
              this.set('refCollectionField', '');
            }

            const attrs = this.getAttributes();
            attrs['data-browse'] = `Drag Files or Click to Browse`;
            attrs['name'] = '';
            this.setAttributes(attrs);
          }
        },
        handleRequiredErrorMessageVisibility() {
          const dropzoneRequiredTrait = this.get('dropzoneRequired');
          if (dropzoneRequiredTrait) {
            if (!this.getTrait('dropzoneRequiredErrorMessage')) {
              this.addTrait(
                {
                  type: 'text',
                  label: 'Required Error Message',
                  name: 'dropzoneRequiredErrorMessage',
                  changeProp: 1,
                },
                { at: 2 },
              );
            }
          } else {
            this.set('dropzoneRequiredErrorMessage', '');
            this.removeTrait('dropzoneRequiredErrorMessage');
          }
        },
        async handleGetDropZoneDataFromChange() {
          let collectionForm = this.closestType('collection-form');
          collectionForm = collectionForm
            ? collectionForm
            : this.closestType('login-form')
            ? this.closestType('login-form')
            : this.closestType('sign-up-form');

          const dropzoneDataFrom = this.get('getDropZoneDataFrom');
          const currentUserCollectionFieldTrait = this.getTrait('currentUserCollectionField');
          const currentTenantCollectionFieldTrait = this.getTrait('currentTenantCollectionField');
          const currentUserSettingsCollectionFieldTrait = this.getTrait(
            'currentUserSettingsCollectionField',
          );
          const currentSubTenantCollectionFieldTrait = this.getTrait(
            'currentSubTenantCollectionField',
          );
          const formCollectionFieldTrait = this.getTrait('formCollectionField');
          switch (dropzoneDataFrom) {
            case 'FORM_COLLECTION':
              if (currentUserCollectionFieldTrait) {
                this.set('currentUserCollectionField', '');
                this.removeTrait('currentUserCollectionField');
              }
              if (currentTenantCollectionFieldTrait) {
                this.set('currentTenantCollectionField', '');
                this.removeTrait('currentTenantCollectionField');
              }
              if (currentUserSettingsCollectionFieldTrait) {
                this.set('currentUserSettingsCollectionField', '');
                this.removeTrait('currentUserSettingsCollectionField');
              }
              if (currentSubTenantCollectionFieldTrait) {
                this.set('currentSubTenantCollectionField', '');
                this.removeTrait('currentSubTenantCollectionField');
              }
              if (collectionForm) {
                const formCollectionFieldsTraitConfig = await getFieldsTraits(
                  'collection-file-dropzone-get-content-from-collection',
                  collectionForm.getAttributes()['data-form-collection'],
                  collections,
                );
                if (!formCollectionFieldTrait) {
                  this.addTrait(formCollectionFieldsTraitConfig, {
                    at: this.getTraitIndex('getDropZoneDataFrom') + 1,
                  });
                }
              }
              break;
            case 'CURRENT_USER':
              if (currentTenantCollectionFieldTrait) {
                this.set('currentTenantCollectionField', '');
                this.removeTrait('currentTenantCollectionField');
              }
              if (currentUserSettingsCollectionFieldTrait) {
                this.set('currentUserSettingsCollectionField', '');
                this.removeTrait('currentUserSettingsCollectionField');
              }
              if (formCollectionFieldTrait) {
                this.set('formCollectionField', '');
                this.removeTrait('formCollectionField');
              }
              if (currentSubTenantCollectionFieldTrait) {
                this.set('currentSubTenantCollectionField', '');
                this.removeTrait('currentSubTenantCollectionField');
              }
              if (collectionForm) {
                const currentUserCollectionFieldsTraitConfig = await getCurrentUserFieldsTraits(
                  this.get('type'),
                  'user',
                  collections,
                );
                if (!currentUserCollectionFieldTrait) {
                  this.addTrait(currentUserCollectionFieldsTraitConfig, {
                    at: this.getTraitIndex('getDropZoneDataFrom') + 1,
                  });
                }
              }
              break;
            case 'CURRENT_TENANT':
              if (currentUserCollectionFieldTrait) {
                this.set('currentUserCollectionField', '');
                this.removeTrait('currentUserCollectionField');
              }
              if (currentUserSettingsCollectionFieldTrait) {
                this.set('currentUserSettingsCollectionField', '');
                this.removeTrait('currentUserSettingsCollectionField');
              }
              if (formCollectionFieldTrait) {
                this.set('formCollectionField', '');
                this.removeTrait('formCollectionField');
              }
              if (currentSubTenantCollectionFieldTrait) {
                this.set('currentSubTenantCollectionField', '');
                this.removeTrait('currentSubTenantCollectionField');
              }
              if (collectionForm) {
                const multiTenantCollectionName = collections.find(
                  (coll) => coll.uuid === multiTenantCollection,
                ).collectionName;
                if (multiTenantCollectionName) {
                  const currentTenantCollectionFieldsTraitConfig =
                    await getCurrentTenantFieldsTraits(
                      this.get('type'),
                      multiTenantCollectionName,
                      collections,
                      multiTenantCollection,
                    );
                  if (!currentTenantCollectionFieldTrait) {
                    this.addTrait(currentTenantCollectionFieldsTraitConfig, {
                      at: this.getTraitIndex('getDropZoneDataFrom') + 1,
                    });
                  }
                }
              }
              break;
            case 'CURRENT_USER_SETTINGS':
              if (currentUserCollectionFieldTrait) {
                this.set('currentUserCollectionField', '');
                this.removeTrait('currentUserCollectionField');
              }
              if (currentTenantCollectionFieldTrait) {
                this.set('currentTenantCollectionField', '');
                this.removeTrait('currentTenantCollectionField');
              }
              if (formCollectionFieldTrait) {
                this.set('formCollectionField', '');
                this.removeTrait('formCollectionField');
              }
              if (currentSubTenantCollectionFieldTrait) {
                this.set('currentSubTenantCollectionField', '');
                this.removeTrait('currentSubTenantCollectionField');
              }
              if (collectionForm) {
                const userSettingsCollectionName = collections.find(
                  (coll) => coll.uuid === userSettingsCollection,
                ).collectionName;
                if (userSettingsCollectionName) {
                  const currentUserSettingsCollectionFieldsTraitConfig =
                    await getCurrentUserSettingsFieldsTraits(
                      this.get('type'),
                      userSettingsCollectionName,
                      collections,
                      userSettingsCollection,
                    );
                  if (!currentUserSettingsCollectionFieldTrait) {
                    this.addTrait(currentUserSettingsCollectionFieldsTraitConfig, {
                      at: this.getTraitIndex('getDropZoneDataFrom') + 1,
                    });
                  }
                }
              }
              break;
            case 'CURRENT_SUB_TENANT':
              if (currentUserCollectionFieldTrait) {
                this.set('currentUserCollectionField', '');
                this.removeTrait('currentUserCollectionField');
              }
              if (currentTenantCollectionFieldTrait) {
                this.set('currentTenantCollectionField', '');
                this.removeTrait('currentTenantCollectionField');
              }
              if (formCollectionFieldTrait) {
                this.set('formCollectionField', '');
                this.removeTrait('formCollectionField');
              }
              if (currentUserSettingsCollectionFieldTrait) {
                this.set('currentUserSettingsCollectionField', '');
                this.removeTrait('currentUserSettingsCollectionField');
              }
              if (collectionForm) {
                const subTenantCollectionName = collections.find(
                  (coll) => coll.uuid === subTenantCollection,
                ).collectionName;
                if (subTenantCollectionName) {
                  const currentSubTenantCollectionFieldsTraitConfig =
                    await getCurrentSubTenantFieldsTraits(
                      this.get('type'),
                      subTenantCollectionName,
                      collections,
                      subTenantCollection,
                    );
                  if (!currentSubTenantCollectionFieldTrait) {
                    this.addTrait(currentSubTenantCollectionFieldsTraitConfig, {
                      at: this.getTraitIndex('getDropZoneDataFrom') + 1,
                    });
                  }
                }
              }
              break;
            default:
              if (currentUserCollectionFieldTrait) {
                this.set('currentUserCollectionField', '');
                this.removeTrait('currentUserCollectionField');
              }
              if (currentTenantCollectionFieldTrait) {
                this.set('currentTenantCollectionField', '');
                this.removeTrait('currentTenantCollectionField');
              }
              if (currentUserSettingsCollectionFieldTrait) {
                this.set('currentUserSettingsCollectionField', '');
                this.removeTrait('currentUserSettingsCollectionField');
              }
              if (currentSubTenantCollectionFieldTrait) {
                this.set('currentSubTenantCollectionField', '');
                this.removeTrait('currentSubTenantCollectionField');
              }
              if (formCollectionFieldTrait) {
                this.set('formCollectionField', '');
                this.removeTrait('formCollectionField');
              }
              break;
          }
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === 'collection-file-dropzone') {
            return { type: 'collection-file-dropzone' };
          }
        },
      },
    ),
    view: defaultView.extend({
      events: {
        submit(e) {
          e.preventDefault();
        },
      },
      init({ model }) {
        this.listenTo(
          model,
          'change:collectionFormFileDropzone change:dropzoneRequired change:dropzoneMaxSize change:dropzoneRequiredErrorMessage',
          this.updateScript,
        );
      },
    }),
  });
  domc.addType('date', {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          droppable: ':not(form)',
          draggable: ':not(form)',
          projectId: projectId,
          version: version,
          traits: [
            ...domc.getType('input').model.prototype.defaults.traits,
            {
              type: 'select',
              label: `Source Date Format</br><small>(When different than project's date format)</small>`,
              title: 'Source Date Format (Optional)',
              info: `When source date format is different than project's date format`,
              name: 'sourceDateFormat',
              options: [{ value: '', name: '- Select -' }, ...dateFormatOptions()],
            },
          ],
        },
        init() {},
      },
      {
        isComponent(el) {
          if (el.tagName === 'INPUT' && el.type === 'date') {
            return { type: 'date' };
          }
        },
      },
    ),
    view: defaultView.extend({
      events: {
        submit(e) {
          e.preventDefault();
        },
      },
    }),
  });
}

export const getTraitForItemIdField = async (
  component,
  attrs,
  dataItemIdFromValue,
  itemIdFieldTrait,
  collections,
  pageCollection,
  multiTenantCollection,
  userSettingsCollection,
  subTenantCollection,
  dataItemIdFieldValue = '',
  snippetType = '',
) => {
  const multiTenantCollectionObj = collections.find(
    (collection) => collection.uuid === multiTenantCollection,
  );
  const userSettingsCollectionObj = collections.find(
    (collection) => collection.uuid === userSettingsCollection,
  );
  const subTenantCollectionObj = collections.find(
    (collection) => collection.uuid === subTenantCollection,
  );

  const entityStorageKeyTrait = component.getTrait('entityStorageKey');
  if (dataItemIdFromValue === 'BROWSER_SESSION_STORAGE') {
    if (!itemIdFieldTrait) {
      component.addTrait(
        {
          name: 'itemIdField',
          label: 'Browser Storage Field',
          type: 'text',
          value: dataItemIdFieldValue,
        },
        { at: component.getTraitIndex('getDataItemIdFrom') + 1 },
      );
      component.removeTrait('createItem');
    }
  } else if (dataItemIdFromValue === 'ENTITY_COLLECTION') {
    if (!entityStorageKeyTrait) {
      const collectionOptions = collections.map((coll) => ({
        value: coll.collectionName,
        name: coll.collectionTitle,
      }));
      component.addTrait(
        {
          name: 'entityStorageKey',
          label: 'Collection',
          type: 'select',
          options: [{ id: '', name: '- Select One -' }, ...collectionOptions],
          value: '',
          changeProp: 1,
        },
        { at: component.getTraitIndex('getDataItemIdFrom') + 1 },
      );
    }
  } else {
    let traitCollectionName = '';
    switch (dataItemIdFromValue) {
      case 'PARENT_COLLECTION':
        const { parentCollectionName } = findDetailsComponentCollection(
          component,
          snippetType,
          pageCollection,
        );
        traitCollectionName = parentCollectionName;
        break;
      case 'PAGE_COLLECTION':
        const pageCollectionName = pageCollection ? pageCollection.collectionId : '';
        traitCollectionName = pageCollectionName;
        break;
      case 'CURRENT_USER_FIELD':
        traitCollectionName = 'user';
        break;
      case 'CURRENT_TENANT_FIELD':
        traitCollectionName = multiTenantCollectionObj
          ? multiTenantCollectionObj.collectionName
          : '';
        break;
      case 'CURRENT_USER_SETTINGS_FIELD':
        traitCollectionName = userSettingsCollectionObj
          ? userSettingsCollectionObj.collectionName
          : '';
        break;
      case 'CURRENT_SUB_TENANT_FIELD':
        traitCollectionName = subTenantCollectionObj ? subTenantCollectionObj.collectionName : '';
        break;
      default:
        if (attrs && attrs['itemIdField']) delete attrs['itemIdField'];
        component.setAttributes(attrs);
        break;
    }
    if (traitCollectionName) {
      await addCollectionFieldTrait(
        component,
        collections,
        traitCollectionName,
        'getDataItemIdFrom',
        itemIdFieldTrait,
        dataItemIdFieldValue,
      );
    }

    if (dataItemIdFromValue === 'CURRENT_TENANT_FIELD') {
      attrs['data-tenant-collection'] = multiTenantCollectionObj.collectionName;
    } else {
      if (attrs['data-tenant-collection']) delete attrs['data-tenant-collection'];
    }
    if (dataItemIdFromValue === 'CURRENT_USER_SETTINGS_FIELD') {
      attrs['data-user-settings-collection'] = userSettingsCollectionObj.collectionName;
    } else {
      if (attrs['data-user-settings-collection']) delete attrs['data-user-settings-collection'];
    }
    if (dataItemIdFromValue === 'CURRENT_SUB_TENANT_FIELD') {
      attrs['data-sub-tenant-collection'] = subTenantCollectionObj.collectionName;
    } else {
      if (attrs['data-sub-tenant-collection']) delete attrs['data-sub-tenant-collection'];
    }
  }
};

export const addCollectionFieldTrait = async (
  component,
  collections,
  collectionName,
  indexTraitName,
  itemIdFieldTrait,
  dataItemIdFieldValue,
) => {
  if (collectionName) {
    const currentCollectionFieldsTraitConfig = await getDataItemIdFieldsTraits(
      'itemIdField',
      'input',
      collectionName,
      collections,
      '',
    );
    if (!itemIdFieldTrait) {
      if (currentCollectionFieldsTraitConfig) {
        const traitObj = dataItemIdFieldValue
          ? {
              ...currentCollectionFieldsTraitConfig,
              changeProp: 1,
              value: dataItemIdFieldValue,
            }
          : { ...currentCollectionFieldsTraitConfig, changeProp: 1 };
        component.addTrait(traitObj, {
          at: component.getTraitIndex(indexTraitName) + 1,
        });
      }
    }
  }
};
